import { Box, Stack, Typography } from "@mui/material";

export default function ElysiumLogo ({black, noText, width, classic}) {

    const Logo = () => {
        if (black) return (
            <Box 
            component="img"
            src="/ELYSIUM EMR LOGO - Black.png" 
            alt="ELYSIUM EMR" 
            sx={{
                width: width ? width : 80,
            }}  
            />
        )
        if (classic) return (
            <Box 
            component="img"
            src="/Elysium_logo.png" 
            alt="ELYSIUM EMR" 
            sx={{
                width: width ? width : 80,
            }}  
            />
        )

        return (
            <Box 
            component="img"
            src="/ELYSIUM EMR LOGO - White.png" 
            alt="ELYSIUM EMR" 
            sx={{
                width: width ? width : 80,
            }}  
            />
        )
    }

    if (noText) return <Logo />
    
    return (
        <Box>
            <Stack>
                <Logo />
                <Typography fontSize={8} color={"primary"} variant="button">Stable 2.3.0</Typography>
            </Stack>
        </Box>
    )
}